import Image from 'next/image'

const PARTNER_LIST = [
  {
    icon: './images/mb_logo.webp',
    title: 'MBBank',
  },
  {
    icon: './images/vpbank_logo.webp',
    title: 'VPBank',
  },
  {
    icon: './images/vega_logo.webp',
    title: 'Vega',
  },
  {
    icon: './images/kbank_logo.webp',
    title: 'KBank',
  },
]

export default function Partner() {
  return (
    <div id="doi-tac" className="flex justify-center  ">
      <div className="max-w-[1920px]">
        <div className="flex flex-col items-center gap-6 bg-brand-primary-25 pt-8 pb-6  px-[30px] rounded-2xl xl:w-[1200px] lg:w-[1114px] md:w-[704px] w-[343px]">
          <div className="flex flex-col gap-2 text-center">
            <h2
              id="partner-title"
              className="text-navy lg:text-[30px] lg:leading-9 font-bold "
            >
              Đối tác của KiotViet là các ngân hàng uy tín hàng đầu
            </h2>
            <div className="font-normal lg:text-base text-sm text-brand-navy">
              Đảm bảo chính sách tốt nhất và thông tin được bảo mật an toàn nhất
            </div>
          </div>
          <div className="flex md:flex-row flex-col md:gap-10 gap-6 items-center ">
            {PARTNER_LIST.map((partner, index) => {
              return (
                <div
                  key={index}
                  className="flex items-center flex-col md:gap-10 gap-6 w-fit"
                >
                  <div className="flex items-center relative lg:w-[238px] lg:h-[82px] 
                  w-[174px] h-[60px] md:w-[145px] md:h-[50px]">
                    <Image alt={partner.title} src={partner.icon} fill={true} />
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}
